import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { Link, useLocation } from "react-router-dom";
import EnterpriseService from "../../common/services/enterprise-service";
import { useContext } from "react";
import { EnterpriseContext } from "../../components/enterprise/EnterpriseContext";
import LazyImage from "./common/LazyImage";

const SidebarSection = ({ label }) => (
  <div className="sidebar-section-label">{label}</div>
);

const MenuItem = ({ to, icon, iconClass, label, active }) => (
  <Link to={to} className={classNames("vtc-menu-item", { active })}>
    <span className="vtc-menu-icon">
      <FontAwesomeIcon className={iconClass} icon={icon} fixedWidth />
    </span>
    <span className="vtc-menu-title">{label}</span>
  </Link>
);

export default function VTCMenu({ container, active }) {
  const { globalContext } = useContext(EnterpriseContext);
  const es = new EnterpriseService();

  if (globalContext.member == null || globalContext.company == null) return null;

  const isEco = globalContext.company.company_type === "realistic" || globalContext.company.company_type === "both";

  return (
    <div className="bg-secondary text-white sidebar rounded d-none d-lg-block" id="sidebar-wrapper">
      {/* Company logo */}
      <div className="sidebar-heading text-center mb-4">
        <LazyImage
          src={globalContext.member.company.avatar_url}
          className="h-90px rounded"
          placeholder="/assets/company-placeholder.png"
        />
      </div>

      <div className="vtc-menu">

        {/* ── Company ─────────────────────────── */}
        <SidebarSection label={container.localeManager.strings.company || "Company"} />
        <MenuItem to="/vtchub" icon="home" iconClass="text-white" label={container.localeManager.strings.dashboard} active={active === "/vtchub"} />
        {es.can(globalContext.member, "company.*") && (
          <MenuItem to="/company/settings" icon="cog" iconClass="text-primary" label={container.localeManager.strings.companySettings} active={active === "/company/settings"} />
        )}

        {/* ── Members ─────────────────────────── */}
        <SidebarSection label={container.localeManager.strings.members || "Members"} />
        <MenuItem to="/company/members" icon="users" iconClass="text-info" label={container.localeManager.strings.members} active={active === "/company/members"} />
        {es.can(globalContext.member, "members.manage_roles") && (
          <>
            <MenuItem to="/company/roles" icon="user-shield" iconClass="text-primary" label={container.localeManager.strings.roles} active={active === "/company/roles"} />
            <MenuItem to="/company/tags" icon="tags" iconClass="text-info" label={container.localeManager.strings.tags} active={active === "/company/tags"} />
            <MenuItem to="/company/ranks" icon="trophy" iconClass="text-success" label={container.localeManager.strings.ranks} active={active === "/company/ranks"} />
          </>
        )}
        {es.can(globalContext.member, "members.manage_applications") && (
          <MenuItem to="/applications" icon="file-signature" iconClass="text-primary" label={container.localeManager.strings.applications} active={active === "/applications"} />
        )}

        {/* ── Activity ─────────────────────────── */}
        <SidebarSection label="Jobs" />
        <MenuItem to="/jobs" icon="route" iconClass="text-info" label={container.localeManager.strings.jobs} active={active === "/jobs"} />
        <MenuItem to="/stats" icon="chart-line" iconClass="text-primary" label={container.localeManager.strings.stats} active={active === "/stats"} />

        {/* ── Fleet & Finance (eco only) ────────── */}
        {isEco && (
          <>
            <SidebarSection label="Fleet & Finance" />
            <MenuItem to="/balance" icon="wallet" iconClass="text-success" label={container.localeManager.strings.balance} active={active === "/balance"} />
            <MenuItem to="/garages" icon="warehouse" iconClass="text-success" label={container.localeManager.strings.garages} active={active === "/garages"} />
            <MenuItem to="/vehicles" icon="truck" iconClass="text-primary" label={container.localeManager.strings.fleet} active={active === "/vehicles"} />
            <MenuItem to="/maintenances" icon="screwdriver-wrench" iconClass="text-danger" label={container.localeManager.strings.maintenance} active={active === "/maintenances"} />
          </>
        )}

        {/* ── Events ───────────────────────────── */}
        <SidebarSection label={container.localeManager.strings.events || "Events"} />
        <MenuItem to="/company/events/calendar" icon="calendar" iconClass="text-info" label={container.localeManager.strings.calendar} active={active === "/company/events/calendar"} />
        {es.can(globalContext.member, "events.manage") && (
          <MenuItem to="/company/events" icon="calendar-days" iconClass="text-info" label={container.localeManager.strings.events} active={active === "/company/events"} />
        )}

        {/* ── Content ──────────────────────────── */}
        {(es.can(globalContext.member, "feeds.manage") || es.can(globalContext.member, "achievements.manage") || es.can(globalContext.member, "company.*")) && (
          <>
            <SidebarSection label="Content" />
            {es.can(globalContext.member, "feeds.manage") && (
              <MenuItem to="/feeds/manage" icon="newspaper" iconClass="text-primary" label={container.localeManager.strings.newsFeed} active={active === "/feeds/manage"} />
            )}
            {es.can(globalContext.member, "achievements.manage") && (
              <MenuItem to="/company/achievements" icon="trophy" iconClass="text-warning" label={container.localeManager.strings.achievements} active={active === "/company/achievements"} />
            )}
            {es.can(globalContext.member, "company.*") && (
              <MenuItem to="/company/logs" icon="clipboard-list" iconClass="text-info" label={container.localeManager.strings.logs} active={active === "/company/logs"} />
            )}
          </>
        )}

        {/* ── Market (eco only) ────────────────── */}
        {isEco && (
          <>
            <SidebarSection label={container.localeManager.strings.globalMarket || "Market"} />
            <MenuItem to="/market/1" icon="earth-europe" iconClass="text-success" label={container.localeManager.strings.europe} active={active === "/market/1"} />
            <MenuItem to="/market/2" icon="earth-americas" iconClass="text-success" label={container.localeManager.strings.usa} active={active === "/market/2"} />
          </>
        )}

      </div>
    </div>
  );
}
